<div class="bg-image"></div>
<div class="row col-12 justify-content-center">
    <div class="row col-12 login-block">
        <div class="col-12 col-lg-6">
            <div class="col-12 text-center">
                <img src="assets/img/UnityC_RGB_app.svg" class="img-fluid" alt="UnityC Logo">
            </div>
            <div class="row col-12 padding-top-20 d-none d-lg-block login-page-text">
                <div>
                    <span class="primary">C</span>onnect
                    <span class="padding-left-10 padding-right-10">|</span>
                    <span class="primary">C</span>ollaborate
                    <span class="padding-left-10 padding-right-10">|</span>
                    <span class="primary">C</span>ommunity
                </div>
                <div class="padding-top-20 primary">
                    Your Secure Connection to Canadian Law Offices
                </div>
            </div>

        </div>
        <div class="col-12 col-lg-6">
            <div class="login-card">
                <form [formGroup]="formGroup">
                    <header>Login</header>
                    <div>
                        <mat-form-field appearance="legacy" >
                            <mat-label>Email</mat-label>
                            <input matInput formControlName="loginId" required autocomplete="off" my-auto-focus>
                            <mat-error>Email is required</mat-error>
                        </mat-form-field>
                    </div>
                    <div>
                        <mat-form-field appearance="legacy" >
                            <mat-label>Password</mat-label>
                            <input matInput [type]="!isCurrentPasswordVisible ? 'password' : 'text'" formControlName="password" required autocomplete="off">
                            <span mat-icon-button matSuffix class="cursor-pointer"
                                  (click)="isCurrentPasswordVisible = !isCurrentPasswordVisible"
                                  [attr.aria-label]="'Hide password'"
                                  [attr.aria-pressed]="!isCurrentPasswordVisible">
                                <mat-icon>{{!isCurrentPasswordVisible ? 'visibility_off' : 'visibility'}}</mat-icon>
                            </span>
                            <mat-error>Password is required</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="remember-me">
                        <mat-checkbox class="regular-font" color='primary'
                                      formControlName="rememberMe">Remember me
                        </mat-checkbox>
                    </div>
                    <div class="login-btn padding-top-20">
                        <button class="bold-font col-12" mat-raised-button color="accent" (click)="signIn()">LOGIN</button>
                    </div>
                    <div class="text-center padding-top-20">
                        <a [routerLink]="['../forgot-password/']"
                           [state]="{loginId : formGroup.controls['loginId'].value}">Forgot Your Password?</a>
                    </div>
                    <div class="text-center padding-top-20">
                        Don't have an account? <a [routerLink]="['../register/']" >Register</a>
                    </div>

                </form>
            </div>

        </div>
    </div>
    <div  class="row col-12 footer-block d-none d-lg-block justify-content-lg-center">
        <dp-footer></dp-footer>
    </div>
</div>
